module.exports = __webpack_public_path__ + "static/media/icon-facebook.de0a63b8.svg";